import { createRequestHelper } from '@utils/swr'
import { type MerchantProfileRequest } from '../types/apiRequest'
import { type MerchantProfileResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['merchantProfile'], MerchantProfileResponse, MerchantProfileRequest>({
  client: 'fortune',
  key: params => params?.code && params.merchant_id
    ? `/campaigns/${params.code}/merchants/${params.merchant_id}/profile`
    : null,
  isImmutable: true,
})

export const useApiMerchantProfile = useRequest
